export default {
  title: "Mise à jour de l'heure !",
  labels: {
    old_time: 'Heure de retrait précédente :',
    new_time: 'Nouvelle heure de retrait :',
    old_serve_time: 'Heure de service précédente :',
    new_serve_time: 'Nouvelle heure de service :',
  },
  buttons: {
    print: 'Imprimer & Fermer',
    got_it: 'Compris',
  },
  feedback: {
    new_prep_time:
      "L'heure de livraison a été mise à jour. Veuillez ajuster votre planning de préparation en conséquence.",
  },
  toasts: {
    something_went_wrong: "Une erreur s'est produite, veuillez réessayer",
  },
};
